import type { ApiResponse } from '@/store/types'
import { post } from '@/backend/api'
import type { ParsedError } from '@/backend/error'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'
import type { UUID } from '@/backend/schema/uuid'

/**
 * Activates a specific instruction version on backend
 */
export const activateInstructionVersion = async (params: {
  team_slug: string
  instruction_id: UUID
  version_id: UUID
}): Promise<ApiResponse<void> | ParsedError> => {
  const { team_slug, instruction_id, version_id } = params
  const path = `v2/teams/${team_slug}/ai_review/instructions/${instruction_id}/versions/${version_id}/activate`

  try {
    const response = await post<void>(path)
    return response
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }

    return parseError(error, errorMessages.INSTRUCTION_VERSION_ACTIVATE)
  }
}
